import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Close from "../other-icons/Close";

import "./budget-floating-widget.m.css";

const SESSION_STORAGE_KEY = "karunadotsava_widget_closed";

function BudgetFloatingWidget() {
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""));
  const [showWidgetButton, setShowWidgetButton] = useState(false);

  useEffect(() => {
    try {
      const isClosed = sessionStorage.getItem(SESSION_STORAGE_KEY);
      const pathname = typeof window !== "undefined" ? window.location.pathname : currentPath;
      const isTargetPage = pathname === "/karunadotsava" || pathname === "/karunadotsava/";

      if (!isClosed && !isTargetPage) {
        setShowWidgetButton(true);
      } else {
        setShowWidgetButton(false);
      }
    } catch (e) {
      setShowWidgetButton(true);
    }
  }, [currentPath]);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowWidgetButton(false);
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
    } catch (err) {
      // ignore storage access issues
    }
  };

  return (
    <>
      {showWidgetButton && (
        <div styleName="budget-toggle-widget-wrapper" className="budget-floating-widget">
          <div styleName="button-and-close-wrapper">
            <span
              styleName="close-widget-button"
              onClick={handleClose}
              role="button"
              aria-label="Close widget"
            >
              <Close color="white" width="10px" height="10px" />
            </span>
            <Link
              styleName="flip-image-wrapper"
              href="https://www.prajavani.net/karunadotsava"
            >
              <div styleName="flip"></div>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default BudgetFloatingWidget;
